import React, { useState, useEffect } from 'react';
import { StudyReportVO } from '@/types/camp/study/studentBaseInfoType';
import ReactECharts from 'echarts-for-react';

interface Props {
  data: StudyReportVO;
  campName: string;
}
const Echarts: React.FC<Props> = ({ data, campName }) => {
  const [options, setOptions] = useState<{}>();
  const valueList: any = [];
  const studyNodeList: any = [];

  function insertNewLines(str: any) {
    let result = '';
    for (let i = 0; i < str.length; i += 7) {
      let chunk = str.substr(i, 7);
      result += chunk;
      if (i + 7 < str.length) {
        result += '\n';
      }
    }
    return result;
  }

  data &&
    data.studyNodeList.map((item) => {
      if (item.totalNodeScore > 0) {
        // console.log(
        //   'data',
        //   item.name,
        //   item.actualScore,
        //   item.totalNodeScore,
        //   (item.actualScore / item.totalNodeScore) * 100,
        // );
        valueList.push(((item.actualScore / item.totalNodeScore) * 100).toFixed(2));
      } else {
        valueList.push(0);
      }
    });
  data &&
    data.studyNodeList.map((item) =>
      studyNodeList.push({ name: insertNewLines(item.name), max: 100 }),
    );

  const option = {
    tooltip: {
      trigger: 'axis',
    },

    radar: {
      // 雷达图的指示器，表示多个变量的名称
      axisName: {
        color: '#5E7288',
      },
      // 雷达图的半径
      radius: ['0', '66%'],
      indicator: studyNodeList,
      axisLine: {
        show: true, // 显示轴线
        lineStyle: {
          color: '#ccc',
          width: 1,
        },
      },
    },
    series: [
      {
        type: 'radar',
        symbolSize: 0,
        tooltip: {
          trigger: 'item',
          formatter: function (params: any) {
            // console.log('params', params);
            // console.log('option', option);
            let result = `${params.name}<br/>`;
            params.value.forEach((value: any, index: any) => {
              const indicatorName = option.radar.indicator[index].name;
              result += `${indicatorName}: ${value}%<br/>`;
            });
            return result;
          },
        },
        areaStyle: {
          color: 'rgba(33, 150, 243, 0.4)',
        },
        lineStyle: {
          color: '#009dff',
          width: 1,
        },
        // 雷达图的数据
        data: [
          {
            value: valueList,
            name: campName,
          },
        ],
      },
    ],
  };

  useEffect(() => {
    setTimeout(function () {
      // console.log('studyNodeList', studyNodeList);
      // console.log('valueList', valueList);
      setOptions(option);
    }, 500);
  }, []);

  return (
    <div>
      <div>{options && <ReactECharts option={options} />}</div>
    </div>
  );
};
export default Echarts;
